import React from 'react';
import styled from 'styled-components';

const Container = styled.div`
  padding: 1rem;
`;

export default () => <Container>You currently have no offers.</Container>;
